const handleInputFocus = (id: string) => {
	const element = document.getElementById(id);

	if (element) {
		element.focus();
	} else {
		console.error(`Element with ID ${id} not found.`);
	}
};

export default handleInputFocus;
